export default {
    name:'loader',
    props:['uploading','processing']
}